<template>
  <list-layout 
    no-counts
    no-search
    no-apply-btn
    >
    <template v-slot:beforeFilters>
      <b-row>
        <b-col>
          <filter-builder
            :id="userPreferenceNames.PAYOUTS_REPORT_FILTER"
            :filters="filters"
            :apply-filters="applyFilters"
            :reset-filters="resetFilters"
            :filters-pending="filtersPending"
            :filters-applied="filtersApplied"
            @sorted="onSorted"
          />
        </b-col>
      </b-row>
    </template>

    <template v-slot:table>
      <t-table
        :columns="columns"
        :options="options"
        :limit="limit"
        ref="reportlist"
        id="report-list-table"
        @loaded="onLoaded"
        @sorted="onSorted"
        @pagination="onPagination"
        @loading="onLoading"
      >
        <template v-slot:counts>
          <div class="d-flex">
            <pagination
              class="smaller p-0"
              :page="page"
              :count="count"
              :loading="loading"
              v-model="limit"
              @limit="onLimit"
            />
          </div>
        </template>
    </t-table>
    </template>
    </list-layout>
</template>

<script>
import { capitalize, upperCase } from "lodash"
import { filterTypes, perPageItemsLg, userPreferenceNames } from "@/constants"
import FilterBuilder from "@/components/FilterBuilder"
import Pagination from "@/components/Pagination"
import { listRouteMixin } from "@/utils/mixins"

export default {
  name: "ReportSection",
  mixins: [listRouteMixin],
  components: { FilterBuilder,Pagination },
  computed: {},
  methods: {
    onLoaded ({ data }) {
      this.count = data.count
      this.summary = data.summary
      this.loading = false
    },
  },
  watch: {},
  data () {
    return {
      page: 1,
      count: 0,
      limit: perPageItemsLg,
      loading: false,
      userPreferenceNames,
      capitalize,
      columns: [
        "payeeId",
        "result",
        "netAmount",
        "description",
      ],
      filters: {
        id: { value: "", defaultValue: "", type: filterTypes.TEXT, label: upperCase(this.$t("id"))+"#" },
        result: { value: "", defaultValue: "", type: filterTypes.TEXT, label: capitalize(this.$t("result")) },
        netAmount: { value: "", defaultValue: "", type: filterTypes.TEXT, label: capitalize(this.$t("net_amount")) },
        description: { value: "", defaultValue: "", type: filterTypes.TEXT, label: capitalize(this.$t("description")) },
      },
      options: {
        sortable: [
          "payeeId",
          "result",
          "netAmount",
          "description",
        ],
        headings: {
          payeeId: this.$t("payee_id")+"#",
          result: capitalize(this.$t("result")),
          netAmount: capitalize(this.$t("net_amount")),
          description: capitalize(this.$t("description")),
        },
        columnsClasses: {},
        responseAdapter ({ data }) {
          return {
            data: data.results,
            count: data.count,
          }
        },
        requestFunction () {},
      }
    }
  },
  mounted () {},
}
</script>